import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService, DataService, FireForesightService, SiteTypeService } from 'src/api/services';
import { User,Customer, CustomerSummary, StatusType, Status, Incident, Widget, Note, SiteTwin, Statistics } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';
import { ActivatedRoute } from '@angular/router';
import { IMultiSourceMultiValueWidget, TimeSeriesDetail } from 'src/app/models/dashboard';
import { AbstractDataService } from 'src/service/data.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';
import { MapComponent } from 'src/app/components/map/map.component';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-fire-foresight-incidents',
  templateUrl: './fire-foresight-incidents.component.html',
  styleUrls: ['./fire-foresight-incidents.component.css']
})
export class FireForesightIncidentsComponent implements OnInit, OnDestroy {
  public list : StatusType [];
  public incidentId: number;
  //public incident: Incident;
  //public liveWidget: IMultiSourceMultiValueWidget;
  public latestImageUrl: string;
  public selectedNote: Note;
  public newNote: string;
  public stats: Statistics;

  constructor(
    public app: ApplicationConfigService, 
    public security: AzureAuthService,
    private svc: FireForesightService, 
    public fire: FireService,
    private siteTypeService: SiteTypeService,
    private dataService: DataService,
    private toasterService: ToastrService,
    private route: ActivatedRoute) { 
    // console.log("fire-foresight-admin constructor")
  }

  
  timer: any;
  ngOnInit(): void {    
    //this.fire.get();
    this.svc.FireForesightGetStatistics(this.app.customerId).subscribe(stats => {
        this.stats = stats;
        console.log(this.stats);
    });
    
    if (this.timer == null){
      this.timer = setInterval(() => this.fire.getIncidents(), 30000);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);  
  }

  loadIncident(){
    if (this.fire.incident){
      this.fire.getCamera(this.fire.incident.site.siteId, false, c => {
        // this.map is not loaded - why???
        console.log(this.fire.incident.detections[0]);
        console.log(this.fire.incident);
        //this.map.displaySites([this.fire.camera.twin], this.getIcon, null/*this.showView*/, null, true);
        //this.map.displayBearing(this.fire.camera.twin, this.fire.incident.cameraBearing, 32);
        //this.map.displayDetection(this.fire.camera.twin, this.fire.incident.detections[0].bearing, this.fire.incident.detections[0].width);
      });
      console.log(this.fire.incident);
      const siteUri = this.fire.incident.site.siteUri;
      const imageUri = this.fire.incident.imageFeedUri;
      if (imageUri != null){
        this.dataService.DataGetData({ 
          customerId: this.app.customerId, 
          request:{
            period: '-1h:1h', 
            type: 'media',
            timeZoneOffset: this.app.getTimeZoneOffset(null),
            forceEmbed: false,
            index: 0,
            publishedIdentifier: null,
            siteUri: null,
            timeSeries: {
              single:{
                variable: {
                  uri: imageUri,
                  transforms: null,   
                }       
              }   
            }
          }
        })
        
        //.DataGetData({uri: imageUri, transforms: null, period: 'latest', customerId: this.app.customerId, type:"media", timeZoneOffset: null})
        .subscribe(r => {
          this.latestImageUrl = r.values[0].valueStr;
        });
      }
      //this.liveWidget = {name:"Live",showTitle:false, realTime:false, period:'-1h:1h',refreshInterval:0,timeSeriesList:[{uri:'in-restapi-restapi-southsisters-288',forceEmbed:false,sourceType:'media'} as TimeSeriesDetail]} as IMultiSourceMultiValueWidget;
      //this.map.displaySites([this.fire.incident.site], this.getIcon, null, null);
      //todo: load the camera 
      
    }
  }

  updateStatus(status: StatusType){
    this.fire.incident.status = status;
    this.fire.update(this.fire.incident, () => {
      this.toasterService.success("Updated","Incident");
      this.fire.next(() => this.loadIncident());
    });
  }

  getIcon(site: SiteTwin, pins: any[]){
    const icon = {icon: pins[site.siteType] ?? pins["blueSelected"]};
    return icon;
  }

  addNewNote(){
    this.svc.FireForesightAddNote({incidentId:this.incidentId, notes:this.newNote}).subscribe(n => {
      this.fire.incident.notes.push(n);
      this.newNote = "";
    })
  }
}